import { render, staticRenderFns } from "./import_work_logs_detail.vue?vue&type=template&id=a4e050d4&scoped=true"
import script from "./import_work_logs_detail.vue?vue&type=script&lang=js"
export * from "./import_work_logs_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e050d4",
  null
  
)

export default component.exports